import type { JSX } from "solid-js";

export type FilterType = "all" | "favorites";

export interface SearchResult {
  id: string;
  entry_date: string | null;
  title: string | null;
  body: string | null;
  mood: number | null;
  is_favorite: number | null;
}

export interface QuickAction {
  id: string;
  label: string;
  shortcut?: string;
  icon: () => JSX.Element;
  action: () => void;
}

export const FILTER_TYPES: readonly FilterType[] = ["all", "favorites"];
